import React from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { mediaBreakpoint } from '@services/responsiveProvider';
import { textH4 } from '@features/ui/styles/textStyles';
import Icon, { ICON_NAME } from '@features/ui/components/Icon';

export enum VARIANT {
  INFO,
}

const BANNER_COLORS = {
  [VARIANT.INFO]: {
    container: 'var(--color-blue-light)',
    badge: 'var(--color-blue)',
    text: 'var(--color-white)',
    icon: 'var(--color-white)',
  },
};

const BANNER_ICONS = { [VARIANT.INFO]: ICON_NAME.info };

const BANNER_TEXT = { [VARIANT.INFO]: 'infoBanner_textInfo.message' };

type InfoBannerType = {
  variant?: VARIANT;
  children: React.ReactNode;
  className?:string;
}

const Banner = ({ variant = VARIANT.INFO, children, className }: InfoBannerType) => {
  const { t } = useTranslation();
  return (
    <Container variant={variant} className={className}>
      {children}
      <Badge variant={variant}>
        <Icon name={BANNER_ICONS[variant]} color={BANNER_COLORS[variant].icon} size="24px" />
        <span>{t(BANNER_TEXT[variant])}</span>
      </Badge>
    </Container>
  );
};

export default Banner;

const Container = styled.div<{variant: VARIANT}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ variant }) => BANNER_COLORS[variant].container};
  width: 916px;
  min-height: 120px;
  border-radius: 8px;
  padding: 20px;
  ${mediaBreakpoint.mobile} {
    padding: 20px;
    padding-bottom: 60px;
  }
`;

const Badge = styled.div<{variant: VARIANT}>`
  position: absolute;
  display: flex;
  align-items: center;
  padding: 10px;
  right: 0px;
  bottom: 0px;
  color: ${({ variant }) => BANNER_COLORS[variant].text};
  background: ${({ variant }) => BANNER_COLORS[variant].badge};
  border-radius: 20px 0 8px 0;

  > span:not(:first-child) {
    ${textH4};
    margin-left: 5px;
    text-transform: uppercase;
  }
`;
